import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { reset } from 'redux-form'
import moment from 'moment'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import store from 'services/store'

import { Spinner } from 'controls'
import BrokerValuation from 'components/Calendar/Info/BrokerValuation'
import CustomEvent from 'components/Calendar/Info/CustomEvent'
import Valuation from 'components/Calendar/Info/Valuation'
import Show from 'components/Calendar/Info/Show'
import EventTypes from 'components/Calendar/Info/EventTypes'
import Actions from 'components/Calendar/Info/Actions'

import info, { closeButton as closeButtonStyle } from './styles'

class Info extends PureComponent {
  static propTypes = {
    loading: PropTypes.loading,
    event: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    changeStatusRequestData: PropTypes.object.isRequired,
    onEventModified: PropTypes.func.isRequired,
    onEventRemove: PropTypes.func.isRequired,
    actions: PropTypes.shape({
      changeStatusRequest: PropTypes.func.isRequired
    })
  }

  constructor(props) {
    super(props)
    this.state = {
      eventVisited: false,
      reason: null,
      comment: ''
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      eventDetailsRequestData: {
        finished: finishedEvent,
        error: errorEvent,
        response: responseEvent
      },
      changeStatusRequestData: {
        finished: finishedEventStatus,
        error: errorEventStatus,
        response: responseEventStatus,
        request: requestEventStatus
      },
      deleteAppointmentRequestData: {
        finished: finishedEventDelete,
        error: errorEventDelete,
        response: responseEventDelete
      }
    } = nextProps
    if (
      this.props.eventDetailsRequestData.loading &&
      finishedEvent &&
      !errorEvent
    ) {
      this.setState({
        eventVisited: false,
        reason: null,
        comment: ''
      })
      this.props.actions.reset('appointmentStatus')
    }
    if (
      this.props.changeStatusRequestData.loading &&
      finishedEventStatus &&
      !errorEventStatus
    ) {
      if (
        requestEventStatus.data.status === 'CONFIRMED' ||
        requestEventStatus.data.status === 'SUCCESS'
      ) {
        this.props.onEventModified(this.props.event.id)
      }
      if (
        requestEventStatus.data.status === 'CANCELLED' ||
        requestEventStatus.data.status === 'FAILURE'
      ) {
        this.props.onEventRemove()
      }
    }
    if (
      this.props.deleteAppointmentRequestData.loading &&
      finishedEventDelete &&
      !errorEventDelete
    ) {
      this.props.onEventRemove()
    }
  }

  changeDataSaved = values => {
    this.setState({ ...values })
  }

  eventComponent = event => {
    if (!event) {
      return <EventTypes />
    }
    if (event.type === 'VALUATION') {
      return (
        <Valuation
          event={event}
          onChangeSaveData={this.changeDataSaved}
          eventVisited={this.state.eventVisited}
        />
      )
    }
    if (event.type === 'SHOW') {
      return <Show event={event} />
    }
    if (event.type === 'BROKER_VALUATION') {
      return (
        <BrokerValuation
          event={event}
          onChangeSaveData={this.changeDataSaved}
          eventVisited={this.state.eventVisited}
        />
      )
    }
    if (event.type === 'CUSTOM_EVENT') {
      return <CustomEvent event={event} />
    }
  }

  saveEvent = () => {
    const { eventVisited, reason, comment } = this.state
    this.props.actions.changeStatusRequest(this.props.event.id, {
      status: eventVisited ? 'SUCCESS' : 'FAILURE',
      reason: eventVisited ? null : reason,
      serviceStatus: eventVisited ? 'PENDING' : 'DECLINED',
      comment
    })
  }

  confirmEvent = () =>
    this.props.actions.changeStatusRequest(this.props.event.id, {
      status: 'CONFIRMED'
    })

  cancelEvent = ({ cancellationComment, reason }) =>
    this.props.actions.changeStatusRequest(this.props.event.id, {
      status: 'CANCELLED',
      serviceStatus: 'DECLINED',
      cancellationComment,
      reason
    })

  deleteEvent = () =>
    this.props.actions.deleteAppointmentRequest(this.props.event.id)

  render() {
    const { event, loading } = this.props
    const date = event ? event.start : new Date()
    const headerTitle = event ? 'Fecha de la cita:' : 'Fecha:'
    const hours = event
      ? `${moment(event.start).format('H:mm')} - ${moment(event.end).format(
          'H:mma'
        )}`
      : ''
    const headerDate = `${moment(date).format('ddd, D')} de ${moment(
      date
    ).format('MMM')} ${hours}`
    const eventComponent = this.eventComponent(event)
    return (
      <section className={classnames('info', { hide: !event, event })}>
        <header className="header">
          {loading ? (
            <p>Cardando...</p>
          ) : (
            <Fragment>
              <p className="label">{headerTitle}</p>
              <p className="value">{headerDate}</p>
              {event && (
                <i
                  className={classnames('ion-android-close', 'close-button')}
                  onClick={this.props.onClose}
                />
              )}
            </Fragment>
          )}
        </header>

        {loading ? (
          <div className="loading-event">
            <Spinner size={30} />
          </div>
        ) : (
          <Fragment>
            {eventComponent}
            {event && (
              <footer className="footer">
                <Actions
                  event={event}
                  saveEvent={this.saveEvent}
                  canSaveEvent={this.state.eventVisited || !!this.state.reason}
                  cancelEvent={this.cancelEvent}
                  confirmEvent={this.confirmEvent}
                  deleteEvent={this.deleteEvent}
                />
              </footer>
            )}
          </Fragment>
        )}
        <style jsx>{info}</style>
        <style jsx>{closeButtonStyle}</style>
      </section>
    )
  }
}

const mapStateToProps = state => ({
  eventDetailsRequestData: store.find('appointment').selector(state),
  changeStatusRequestData: store.patch('appointment').selector(state),
  deleteAppointmentRequestData: store.delete('appointment').selector(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      changeStatusRequest: store.patch('appointment').action,
      deleteAppointmentRequest: store.delete('appointment').action,
      reset
    },
    dispatch
  )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Info)
